import React from 'react';
import { type LaunchDarklyFlags } from '@/common/launchDarkly';
import NavHeader from '@/common/navigation/NavHeader';
import { useIsSkySlopeMobileApp } from '@/common/utils';
import { HeaderContext } from '@/context/header-context';
import { useHeaderVariant } from '@/hooks';
import { getUsersGroups } from '@/lib/api/account/accountApi';
import { preferencesUrl } from '@/lib/environment-config';
import { useShallowSelector } from '@/lib/reduxHooks';
import { UserOrigins } from '@/lib/types';

export function useSetEnvBuilderHeaderContent(args: { flags?: LaunchDarklyFlags }) {
  const { flags } = args;
  const isMobileApp = useIsSkySlopeMobileApp();
  const state = useShallowSelector((state) => ({
    settings: state.pageFrame.settings,
    settingsFetched: state.pageFrame.settingsFetched,
  }));

  const headerContext = React.useContext(HeaderContext);
  const { useDefaultHeader } = useHeaderVariant();

  React.useEffect(() => {
    if (!state.settingsFetched || isMobileApp) return;

    headerContext.setContent(
      <NavHeader
        labelName=""
        progressBarPercent={state.settings?.account.userOrigin === UserOrigins.Forms ? 0 : 100}
        preferencesUrl={preferencesUrl}
        getUsersGroups={getUsersGroups}
        useDefaultHeader={useDefaultHeader}
        flags={flags}
        hideNavItems={flags?.['hide-build-ui-elements']}
        showPreferences={flags?.['add-automatic-time-stamp-signatures-to-user-preferences']}
      />
    );

    return () => headerContext.setContent(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [state.settings]);
}
